var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesAnalyticsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-analytics-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-analytics-icon_svg__cls-1{fill:#010101}.websites-analytics-icon_svg__cls-1,.websites-analytics-icon_svg__cls-3{stroke-width:0}.websites-analytics-icon_svg__cls-4,.websites-analytics-icon_svg__cls-5,.websites-analytics-icon_svg__cls-6{stroke:#010101;stroke-miterlimit:10;stroke-width:2px}.websites-analytics-icon_svg__cls-3,.websites-analytics-icon_svg__cls-4{fill:#e84b0f}.websites-analytics-icon_svg__cls-5{fill:#fff}.websites-analytics-icon_svg__cls-6{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.87 32.91c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-6",
    d: "M8.73 61.4h54.41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-5",
    d: "M53.82 33h6.29v28.39h-6.29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-4",
    d: "M43.31 20.86h6.29V61.4h-6.29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-5",
    d: "M32.81 39.08h6.29V61.4h-6.29z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-4",
    d: "M22.27 29.97h6.29V61.4h-6.29z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-5",
    d: "M11.76 48.19h6.29V61.4h-6.29z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-6",
    d: "M15.65 36.16l9.38-16.27M26.58 20.25l8.78 7.59M36.69 27.05l9.38-16.27M47.41 11.23l9.08 10.48"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "websites-analytics-icon_svg__cls-3",
    cx: 25.43,
    cy: 19.22,
    r: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-1",
    d: "M25.43 17.58c.91 0 1.64.73 1.64 1.64s-.73 1.64-1.64 1.64-1.64-.73-1.64-1.64.73-1.64 1.64-1.64m0-2a3.64 3.64 0 100 7.28 3.64 3.64 0 000-7.28z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "websites-analytics-icon_svg__cls-3",
    cx: 14.92,
    cy: 37.44,
    r: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-1",
    d: "M14.92 35.8c.91 0 1.64.73 1.64 1.64s-.73 1.64-1.64 1.64-1.64-.73-1.64-1.64.73-1.64 1.64-1.64m0-2a3.64 3.64 0 100 7.28 3.64 3.64 0 000-7.28z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "websites-analytics-icon_svg__cls-3",
    cx: 35.93,
    cy: 28.33,
    r: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-1",
    d: "M35.93 26.69c.91 0 1.64.73 1.64 1.64s-.73 1.64-1.64 1.64-1.64-.73-1.64-1.64.73-1.64 1.64-1.64m0-2a3.64 3.64 0 100 7.28 3.64 3.64 0 000-7.28z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "websites-analytics-icon_svg__cls-3",
    cx: 46.44,
    cy: 10.11,
    r: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-1",
    d: "M46.44 8.47c.91 0 1.64.73 1.64 1.64s-.73 1.64-1.64 1.64-1.64-.73-1.64-1.64.73-1.64 1.64-1.64m0-2a3.64 3.64 0 100 7.28 3.64 3.64 0 000-7.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "websites-analytics-icon_svg__cls-3",
    cx: 56.94,
    cy: 22.26,
    r: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-analytics-icon_svg__cls-1",
    d: "M56.94 20.62c.91 0 1.64.73 1.64 1.64s-.73 1.64-1.64 1.64-1.64-.73-1.64-1.64.73-1.64 1.64-1.64m0-2a3.64 3.64 0 100 7.28 3.64 3.64 0 000-7.28z"
  })))));
}
export default SvgWebsitesAnalyticsIcon;